import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*
import kotlinx.coroutines.launch

// Nastavení nového hesla po kliknutí na recovery odkaz z e-mailu. Token přišel v URL hashi
// (viz recoveryFromUrl v Auth.kt). Po úspěchu se uživatel rovnou přihlásí (recovery token je platná
// session). onDone(token) -> přihlásit, onDone(null) -> zpět na přihlášení/web.
@Composable
fun ResetPasswordScreen(link: RecoveryLink, onDone: (String?) -> Unit) {
    val accessToken = link.accessToken

    Div(attrs = { classes("card", "login-card") }) {
        H2 { Text("Nastavení nového hesla") }

        if (accessToken == null) {
            Div(attrs = { classes("form-error") }) { Text(link.error ?: "Odkaz je neplatný nebo vypršel.") }
            P(attrs = { classes("muted") }) { Text("Nech si v Supabase vygenerovat nový odkaz pro obnovu hesla.") }
            Button(attrs = { classes("primary-btn"); onClick { onDone(null) } }) { Text("Zpět na přihlášení") }
            return@Div
        }

        var pw by remember { mutableStateOf("") }
        var pw2 by remember { mutableStateOf("") }
        var busy by remember { mutableStateOf(false) }
        var error by remember { mutableStateOf<String?>(null) }
        val scope = rememberCoroutineScope()

        P(attrs = { classes("muted") }) { Text("Zadej nové heslo ke svému účtu.") }
        Input(type = InputType.Password) {
            classes("field"); placeholder("nové heslo"); value(pw); onInput { pw = it.value }
        }
        Input(type = InputType.Password) {
            classes("field"); placeholder("nové heslo znovu"); value(pw2); onInput { pw2 = it.value }
        }
        Button(attrs = {
            classes("primary-btn")
            if (busy) disabled()
            onClick {
                when {
                    pw.length < 6 -> error = "Heslo musí mít aspoň 6 znaků."
                    pw != pw2 -> error = "Hesla se neshodují."
                    else -> {
                        busy = true; error = null
                        scope.launch {
                            try {
                                Api.updatePassword(accessToken, pw)
                                onDone(accessToken) // heslo nastaveno -> rovnou přihlásit
                            } catch (e: Throwable) {
                                error = "Nastavení hesla selhalo: ${e.apiMessage()}"
                            } finally { busy = false }
                        }
                    }
                }
            }
        }) { Text(if (busy) "Ukládám…" else "Nastavit heslo") }
        error?.let { Div(attrs = { classes("form-error") }) { Text(it) } }
    }
}
